import type { CSSValueWithLength } from '../../styles';
import { convertOldButtonProps } from '../button/converter.old';
import type { OldButtonProps } from '../button/converter.old';
import type { FileUploadProps as FileUploadNewProps, UploadFile } from './FileUpload';
import type { FileUploadButtonProps as FileUploadButtonNewProps } from './FileUploadButton';
import type { ImageFile, ImageUploadProps as ImageUploadNewProps } from './ImageUpload';
import type { ImageUploadPreviewProps as ImageUploadPreviewNewProps } from './ImageUploadPreview';

export interface OldFileUploadButtonProps extends Omit<FileUploadButtonNewProps, 'buttonProps' | 'onChange'> {
  buttonProps?: Omit<OldButtonProps, 'onClick' | 'disabled' | 'loading'>;
  /** @deprecated onChange를 대신 사용해주세요. */
  onFileUpload?: (file: File | File[]) => void;
}

export function convertOldFileUploadButtonProps(props: OldFileUploadButtonProps): FileUploadButtonNewProps {
  const { buttonProps, onFileUpload, ...restProps } = props;
  return {
    ...restProps,
    buttonProps: buttonProps ? convertOldButtonProps(buttonProps) : undefined,
    onChange: onFileUpload,
  };
}

export interface OldFileUploadProps
  extends Omit<FileUploadNewProps, 'buttonProps' | 'removable' | 'files' | 'onFileClick' | 'onFileRemove'> {
  buttonProps?: Omit<OldButtonProps, 'onClick' | 'disabled'>;
  /** @deprecated removable을 대신 사용해주세요. */
  showRemoveButton?: boolean;
  /** @deprecated files를 대신 사용해주세요. */
  fileList?: UploadFile[];
  /** @deprecated onFileClick을 대신 사용해주세요. */
  onClickFile?: (file: UploadFile, index: number) => void;
  /** @deprecated maxCount 도달 시 버튼이 자동으로 disabled 처리되어 callback이 호출되지 않아 제거되었습니다. */
  onLimitMaxCount?: () => void;
  /** @deprecated onFileRemove를 대신 사용해주세요. */
  onClickFileRemove?: (file: UploadFile, index: number) => void;
}

export function convertOldFileUploadProps(props: OldFileUploadProps): FileUploadNewProps {
  const { buttonProps, showRemoveButton, fileList, onClickFile, onLimitMaxCount, onClickFileRemove, ...restProps } =
    props;
  void onLimitMaxCount;

  return {
    ...restProps,
    buttonProps: buttonProps ? convertOldButtonProps(buttonProps) : undefined,
    removable: showRemoveButton,
    files: fileList,
    onFileClick: onClickFile,
    onFileRemove: onClickFileRemove,
  };
}

export interface OldImageUploadPreviewProps extends Omit<ImageUploadPreviewNewProps, 'status' | 'radius' | 'onRemove'> {
  /** @deprecated status를 대신 사용해주세요. */
  error?: boolean;
  /** @deprecated radius를 대신 사용해주세요. */
  borderRadius?: CSSValueWithLength;
  /** @deprecated onRemove를 대신 사용해주세요. */
  onClickRemove?: () => void;
}

export function convertOldImageUploadPreviewProps(props: OldImageUploadPreviewProps): ImageUploadPreviewNewProps {
  const { error, borderRadius, onClickRemove, ...restProps } = props;
  return {
    ...restProps,
    status: error ? 'error' : undefined,
    radius: borderRadius,
    onRemove: onClickRemove,
  };
}

export interface OldImageUploadProps
  extends Omit<
    ImageUploadNewProps,
    'removable' | 'files' | 'radius' | 'zIndex' | 'onFileClick' | 'onFileRemove' | 'onOrderChange'
  > {
  /** @deprecated removable을 대신 사용해주세요. */ showRemoveButton?: boolean;
  /** @deprecated files를 대신 사용해주세요. */ fileList?: ImageFile[];
  /** @deprecated radius를 대신 사용해주세요. */ borderRadius?: CSSValueWithLength;
  /** @deprecated zIndex를 대신 사용해주세요. */ z_index?: number;
  /** @deprecated onFileClick을 대신 사용해주세요. */ onClickFile?: (imageUrl: string, index: number) => void;
  /** @deprecated onFileRemove를 대신 사용해주세요. */ onClickFileRemove?: (file: ImageFile, index: number) => void;
  /** @deprecated onOrderChange를 대신 사용해주세요. */ onDragEnd?: (files: ImageFile[]) => void;
}

export function convertOldImageUploadProps(props: OldImageUploadProps): ImageUploadNewProps {
  const { showRemoveButton, fileList, borderRadius, z_index, onClickFile, onClickFileRemove, onDragEnd, ...restProps } =
    props;
  return {
    ...restProps,
    removable: showRemoveButton,
    files: fileList,
    radius: borderRadius,
    zIndex: z_index,
    onFileClick: onClickFile,
    onFileRemove: onClickFileRemove,
    onOrderChange: onDragEnd,
  };
}
